import AlertsWidget from './AlertsWidget';

export default AlertsWidget;
